import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "mitarbeiterform" }
const _hoisted_2 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "Daten werden geladen", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = {
  key: 2,
  class: "row mt-3"
}
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = {
  key: 3,
  class: "row mt-4 align-items-end"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = {
  key: 0,
  class: "row mt-5 mb-2"
}
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { key: 5 }
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-12" }
const _hoisted_21 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabeledInput = _resolveComponent("LabeledInput")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_ZusammenarbeitForm = _resolveComponent("ZusammenarbeitForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.edit && _ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (!_ctx.edit || (_ctx.edit && !_ctx.loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_LabeledInput, {
              label: _ctx.$t('management.firstname'),
              modelValue: _ctx.vorname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vorname) = $event))
            }, null, 8, ["label", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_LabeledInput, {
              label: _ctx.$t('management.lastname'),
              modelValue: _ctx.nachname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nachname) = $event))
            }, null, 8, ["label", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_LabeledInput, {
              label: _ctx.$t('management.email'),
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
            }, null, 8, ["label", "modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.edit || (_ctx.edit && !_ctx.loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_LabeledSelect, {
              label: _ctx.$t('management.unit'),
              modelValue: _ctx.unit,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.unit) = $event)),
              options: _ctx.unitoptions
            }, null, 8, ["label", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_LabeledSelect, {
              label: _ctx.$t('management.role'),
              modelValue: _ctx.role,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.role) = $event)),
              options: _ctx.roleoptions
            }, null, 8, ["label", "modelValue", "options"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.edit || (_ctx.edit && !_ctx.loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.edit ? 'col-12' : 'col-12')
              }, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSaveClick && _ctx.onSaveClick(...args)))
                }, _toDisplayString(_ctx.edit ? _ctx.$t('management.save') : 'User Anlegen'), 1)
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.edit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.$t('management.feedback_title')), 1),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('management.feedback_subtitle', { name: _ctx.name })), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_AutoComplete, {
            modelValue: _ctx.feedbacker_selected,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.feedbacker_selected) = $event)),
            values: _ctx.feedbacker
          }, null, 8, ["modelValue", "values"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveFeedbacker && _ctx.saveFeedbacker(...args)))
              }, _toDisplayString(_ctx.$t('management.save')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_ZusammenarbeitForm, { user: _ctx.userid }, null, 8, ["user"])
        ]))
      : _createCommentVNode("", true)
  ]))
}